import { QueryParams } from '../types';

export const getQueryParam = (name: string): string => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};

export const getQueryParamsString = () => {
  let result = '';

  [QueryParams.ORIGIN, QueryParams.CUSTOM_LANDING].forEach((key) => {
    const value = getQueryParam(key);
    if (value !== null) {
      result += `&${key}=${value}`;
    }
  });
  return result;
};

export const getOriginQueryParam = () => getQueryParam(QueryParams.ORIGIN);
